import { createResourceStore } from './createResourceStore';

const useVocabularyStore = createResourceStore({
  endpoint: '/admin/vocabulary',
  collectionKey: 'vocabulary',
  itemKey: 'vocabulary',
  methods: {
    fetch: 'fetchVocabulary',
    create: 'createVocabulary',
    update: 'updateVocabulary',
    delete: 'deleteVocabulary',
  },
});

export default useVocabularyStore;
